module.exports = __webpack_public_path__ + "images/card-view-icon-86b54563.svg";